// Project data
const projects = [
  {
    id: "gator",
    title: "John Deere Gator of the Future",
    tech: "AR | 3D | WEB",
    description: `
      <p>The Gator of the Future, designed by <strong>Detroit College of Creative Studies</strong> 
      engineering program winners, sponsored by John Deere. We brought their creation to life 
      with this Web AR experience built in 8th Wall. </p>
      
      <p><a class="effect-link" href="https://ar.gatorofthefuture.com/" target="_blank" rel="noopener noreferrer">See for yourself</a></p>
    `,
    slug: "johndeere-gatorfuture",
  },
  {
    id: "livefree",
    title: "Sonic Drive-In Merch Site",
    tech: "3D | WEB | E-COMMERCE",
    description: `
      <p>Welcome to the Department of Research and Deliciousment, Sonic Drive-In's e-commerce 
      website that blends the Live Free Shop Sonic campaign into an immersive 3D shopping experience. </p>
      
      <p><a class="effect-link" href="https://livefreeshopsonic.com" target="_blank" rel="noopener noreferrer">View the Experience</a></p>
    `,
    slug: "sonic-livefree",
  },
  {
    id: "bosch",
    title: "Bosch Night Vision",
    tech: "AR | SOCIAL MEDIA",
    description: `
      <p>We built this Instagram and Facebook AR effect to extend the Bosch Night Vision technology campaign 
      concept of transforming drivers' eyes into those of a nocturnal creature.</p>
    `,
    slug: "bosch-eyes",
  },
  {
    id: "eden",
    title: "Coachella Art Extension",
    tech: "AR | SOCIAL MEDIA | FESTIVAL",
    description: `
      <p>In collaboration with <a href="https://maggiewest.co/coachella" target="_blank" rel="noopener noreferrer">Maggie West</a>, 
      Meta and the Coachella Innovation Team
      we built a virtual extension for one of four large-scale installations at Coachella, <em>Eden</em>, Coachella's 
      first photography installation and one of the world's largest 3D color photography 
      installations.</p>
    `,
    slug: "coachella-eden",
  },
  {
    id: "feast",
    title: "Harvesters Feastival",
    tech: "AR | SOCIAL MEDIA | EVENT",
    description: `
      <p>We’ve all seen the face of hunger. But how could we bring interest to the cause while making it 
      lighthearted enough to get people on board?  Enter the beasts &mdash; our way to remind people that hunger is truly a monster of a problem.</p>
      
      <p>This interactive AR experience created for the 
      <a href="https://www.signaltheory.com/work/harvesters-feastival-event-branding" target="_blank" rel="noopener noreferrer">Harvesters' Feastival</a> pop-up event, 
      highlights the importance of food security and community support by adding a bit of fun to enlighten people on this serious issue.</p>
    `,
    slug: "harvesters-feastival",
  },
  {
    id: "harvest",
    title: "John Deere Harvest Time",
    description: `
      <p>Every season is an opportunity to best the previous year’s production. With this AR filter, 
      we were able to leverage that competitive spirit, allowing farmers to challenge themselves 
      (and their friends) through a game that marked the first of its kind.</p>

      <p>Developed in-house through Meta Spark Studio, <a href="https://www.signaltheory.com/work/john-deere-harvest-time" target="_blank" rel="noopener noreferrer">Harvest Time</a> 
      gamifies the most important time of year 
      for farmers, allowing users to experience the excitement of harvest in a race to see who can haul in 
      the most bushels in 45 seconds. And to top it off, the selfie share function at the end allowed users 
      to tout their high score on social channels.</p>
    `,
    tech: "AR | SOCIAL MEDIA",
    slug: "johndeere-harvesttime",
  },
  {
    id: "everest",
    title: "Nat Geo Everest",
    tech: "AR | SOCIAL MEDIA",
    description: `
     <p>National Geographic's team captured their Everest expedition, then asked us to make the once-in-a-lifetime 
     adventure accessible to their viewers using that content. So, we gave Nat Geo fans a way to gain 30,000 
     feet of elevation in an instant. </p>

    <p>Our immersive <a href="https://www.signaltheory.com/work/nat-geo-everest" target="_blank" rel="noopener noreferrer">AR filter</a> put Instagram 
    users in the middle of Mount Everest’s most famous landscapes, with 
    360-degree views showing exactly what a real climber would see. By moving the camera, users could take in the 
    sights, observe the conditions and learn about each stage of the climb — all from wherever they were.</p>
    `,
    slug: "natgeo-everest",
  },
  {
    id: "modeld",
    title: "John Deere Model D",
    tech: "AR | 3D | WEB",
    description: `
      <p>100 years ago, John Deere released a piece of equipment that changed the game. To celebrate 
      this milestone, we breathed new life into one of their most iconic machines: the 
      <a href="https://www.signaltheory.com/work/john-deere-model-d" target="_blank" rel="noopener noreferrer">Model D tractor</a>.</p>

      <p>Our AR experience let farmers see the Model D on their land, evoking the fond feelings associated with the historic machine. 
      A realistic 3D rendering brought the machine to life, complete with the sound of a running engine.</p>
      
      <p><a class="effect-link" href="https://signals.8thwall.app/model-d/" target="_blank" rel="noopener noreferrer">View the Experience</a></p>
    `,
    slug: "johndeere-modelD",
  },
  {
    id: "lucky",
    title: "Signal Theory Bubbles and Bowties",
    tech: "AR | 3D | WEB",
    description: `
      <p>Signal Theory's focus on human-centered design and connection just wouldn't be the same without the 
      long-standing tradition of hosting annual events for its employees to celebrate working together 
      on award-winning creative marketing. Those traditions were put on pause for three years following 
      Covid-19 stay-at-home protocols, but in 2023 came back with renewed excitement and new traditions.</p>

      <p>The theme for this event is "Bubbles and Bow Ties" and we created this AR experience for everyone to win big with Signal Theory.</p>

      <p><a class="effect-link" href="https://signals.8thwall.app/bubbles-and-bowties" target="_blank" rel="noopener noreferrer">Are you feeling lucky?</a></p>
    `,
    slug: "signaltheory-lucky",
  },
  {
    id: "summer",
    title: "Sonic Summer",
    tech: "AR | SOCIAL MEDIA",
    description: `
      <p>Up against indefinite reside-in-place orders, we needed to bring the “delightful possibility” of summer and SONIC 
      to the masses in a safe, socially distanced way. </p>
      <p>To keep SONIC top-of-mind through the pandemic, we launched unique augmented reality filters that created an 
      engaging <a href="https://www.signaltheory.com/work/sonic-summer-ar" target="_blank" rel="noopener noreferrer">SONIC experience</a> with no visit required. The filters were developed and released leading up to the first 
      official day of summer, and each surprised, delighted and entertained SONIC fans across the country.</p>
    `,
    slug: "sonic-summer",
  },
];

export default projects;
